import { BridgeClient } from 'app/service/bridge/BridgeClient';

/**
 * Creates a payload provider API backed by the bridge transport.
 *
 * Covers:
 *   payload_providers.discover    — list registered provider keys + labels
 *   payload_providers.get_active  — current active provider configs
 *   payload_providers.set         — persist new active provider configs
 */
export function createBridgePayloadProviderApi() {
  const client = new BridgeClient();

  return {
    /**
     * @returns {Promise<{ result: string, providers: Array<{ key: string, label: string, config_schema: object }> }>}
     */
    async discoverProviders() {
      return client.sendMessageWithResponse('payload_providers.discover', {});
    },

    /**
     * @returns {Promise<{ result: string, configs: Array<{ provider_key: string, params: object }> }>}
     */
    async getActiveProviderConfigs() {
      return client.sendMessageWithResponse('payload_providers.get_active', {});
    },

    /**
     * @param {Array<{ provider_key: string, config: object }>} configs
     *   Each entry must have provider_key and config (not params).
     * @returns {Promise<{ result: string }>}
     */
    async saveActiveProviderConfigs(configs) {
      const providers = configs.map((c) => ({
        provider_key: c.provider_key,
        config: c.config !== undefined ? c.config : (c.params || {}),
      }));
      return client.sendMessageWithResponse('payload_providers.set', { providers });
    },
  };
}
